import { useContext, useEffect } from 'react';

import { FORM_CONTROLS_PROPS_SHIPPING } from './constants';

import { useTranslation } from '@conekta/cronos/i18n';
import './FormShipping.scss';
import { ComponentSize } from '@conekta/frontino-ui/common/constants';
import { Icon } from '@conekta/frontino-ui/Icon';
import { IconType } from '@conekta/frontino-ui/Icon/Icon';
import { CheckoutFrameContext } from 'app/context';
import FieldEvaluated from 'app/pages/frames/components/Form/FieldEvaluated';
import { getFormControlProps } from 'app/pages/frames/components/Form/FieldEvaluated/helpers';
import { sendAnalytic } from 'app/util/analytics';
import { AnalyticEvents } from 'app/util/constants';
import { Button } from 'app/components/Button';
import { Form } from 'react-final-form';

export interface FormShippingProps {
  submitButtonText: string;
  isLoading: boolean;
  handleFormSubmit: (values: any) => void;
}

export const FormShipping = ({ submitButtonText, handleFormSubmit, isLoading = false }: FormShippingProps) => {
  const { checkoutRequest } = useContext(CheckoutFrameContext);
  const { t } = useTranslation();
  const { id, companyId, type } = checkoutRequest;

  useEffect(() => {
    sendAnalytic(AnalyticEvents.shipmentInfo, id, companyId, type);
  }, []);

  return (
    <Form
      onSubmit={handleFormSubmit}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} className="ShippingForm__container">
          <div className="ShippingForm">
            <div className="ShippingForm__form">
              <p className="ShippingForm__title">
                <Icon size={ComponentSize.SMALL} className="ShippingForm__title-icon" type={IconType.OUTLINED}>
                  person
                </Icon>
                {t('iFrame.checkout.shippingForm.personalInformationSectionTitle')}
              </p>
              {/* Phone */}
              <FieldEvaluated {...getFormControlProps('shippingContact.phone', FORM_CONTROLS_PROPS_SHIPPING, t)} />
              <p className="ShippingForm__title">
                <Icon size={ComponentSize.SMALL} className="ShippingForm__title-icon" type={IconType.OUTLINED}>
                  local_shipping
                </Icon>
                {t('iFrame.checkout.shippingForm.shippingSectionTitle')}
              </p>
              {/* Street */}
              <FieldEvaluated
                {...getFormControlProps('shippingContact.address.street1', FORM_CONTROLS_PROPS_SHIPPING, t)}
              />
              <div className="fields__phone-and-postalCode">
                {/* Postal Code */}
                <FieldEvaluated
                  {...getFormControlProps('shippingContact.address.postalCode', FORM_CONTROLS_PROPS_SHIPPING, t)}
                />
                {/* State */}
                <FieldEvaluated
                  {...getFormControlProps('shippingContact.address.state', FORM_CONTROLS_PROPS_SHIPPING, t)}
                />
              </div>
              <div className="fields__phone-and-postalCode">
                {/* City */}
                <FieldEvaluated
                  {...getFormControlProps('shippingContact.address.city', FORM_CONTROLS_PROPS_SHIPPING, t)}
                />
                {/* Street 1 (MX Colony) */}
                <FieldEvaluated
                  {...getFormControlProps('shippingContact.address.street2', FORM_CONTROLS_PROPS_SHIPPING, t)}
                />
              </div>
            </div>
          </div>
          <Button
            className="IframeCheckoutAgreement__btn-submit"
            disabled={submitting || isLoading}
            isLoading={submitting || isLoading}
            type="submit"
          >
            {submitButtonText}
          </Button>
        </form>
      )}
    />
  );
};
